// extracted by mini-css-extract-plugin
export default {"text":"osKhM5","activity":"lzISME"};